import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const EVENTOS_CONST = 'eventos';
export const EVENTOS_API = `${baseUrl}/${EVENTOS_CONST}`;

export const allEventosService = async (params) => {
  const res = await axios.get(EVENTOS_API, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEventosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${EVENTOS_API}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(EVENTOS_API, data, { headers: token({}) });
  }
  return res;
};

export const oneEventosService = async (id) => {
  const res = await axios.get(`${EVENTOS_API}/${id}`, { headers: token({}) });
  return res;
};

export const deleteEventosService = async (id) => {
  const res = await axios.delete(`${EVENTOS_API}/${id}`, {
    headers: token({}),
  });
  return res;
};
